<div class="pagetitle">
  <h2>List Users</h2>
  <a [routerLink]="['/dashboard/user/new']" class="btn btn-sm btn-outline-success"><i class="fa fa-fw fa-plus"></i> Create new user</a>
</div>
<alert></alert>
<div class="filter form-row">
  <div class="col-md-6">
    <form [formGroup]="recordLimitForm" class="float-left" novalidate>
      <select class="form-control form-control-sm" formControlName="recordlimit" (change)="updateRecords($event.target.value)">
        @for (option of pagination['options']; track option) {
          <option value="{{option.key}}">{{option.value}}</option>
        }
      </select>
    </form>
  </div>
  <div class="col-md-6">
    <form [formGroup]="userSearchForm" class="float-right" novalidate>
      <input type="text" class="form-control form-control-sm" formControlName="email" placeholder="Username/Email" />
      @if (filter) {
        <i class="fa fa-fw fa-times" (click)="getUsers()"></i>
      }
      @if (!filter) {
        <i class="fa fa-fw fa-search"></i>
      }
    </form>
  </div>
</div>
<div class="table-responsive">
  <table class="table table-bordered table-striped table-sm table-hover" id="dataTable" width="100%" cellspacing="0">
    <thead>
      <tr>
        <th width="250" [index]="0" [resizeColumn]="true" (click)="sort(sortMethodTypes.EMAIL)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.EMAIL, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.EMAIL && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.EMAIL && sortDirection === 'DESC') }">Username/Email</th>

        <th width="180" [index]="1" [resizeColumn]="true" class="sort-na">Phone</th>

        @if (auth.hasAccess('PartnerAdmin')) {
          <th width="" [index]="2" [resizeColumn]="true"  (click)="sort(sortMethodTypes.CUSTOMER_NAME)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.CUSTOMER_NAME, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.CUSTOMER_NAME && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.CUSTOMER_NAME && sortDirection === 'DESC') }">Customer</th>
        }

        @if (auth.hasAccess('SuperAdmin')) {
          <th width="" [index]="2" [resizeColumn]="true"  (click)="sort(sortMethodTypes.PARTNER_NAME)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.PARTNER_NAME, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.PARTNER_NAME && sortDirection === 'ASC'),
          'fa-sort-desc': (sortMethod === sortMethodTypes.PARTNER_NAME && sortDirection === 'DESC') }">Partner</th>
        }

        <th width="100" [index]="3" [resizeColumn]="true" class="text-center sort-na">Status</th>

        <th width="100" [index]="4" [resizeColumn]="true" class="text-center"  (click)="sort(sortMethodTypes.ROLE)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.ROLE, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.ROLE && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.ROLE && sortDirection === 'DESC') }">Role</th>

        <th width="200" [index]="5" [resizeColumn]="true" class="text-center" class="sort-na">Action</th>
      </tr>
    </thead>
    <tbody>
      @if (loading) {
        <tr>
          <td colspan="7" class="loading text-center">
            <span class="">{{msg}}</span>
          </td>
        </tr>
      }
      @for (user of users; track user; let i = $index) {
        <tr data-id="{{user.id}}">
          <td><a [routerLink]="['/dashboard/user/view', user.id]" [state]="{ data: { user: user }}" title="View User">{{user.email}}</a></td>
          <td>{{user.phone}}</td>
          @if (auth.hasAccess('PartnerAdmin')) {
            <td>{{user.customer && user.customer.name}}</td>
          }
          @if (auth.hasAccess('SuperAdmin')) {
            <td>{{ user.partner && user.partner.name }}</td>
          }
          <td class="text-center">
            <span class="badge {{(user.status=='active')? 'badge-success' : 'badge-secondary'}} ">{{user.status}}</span>
          </td>
          <td  class="text-center">{{user.role}}</td>
          @if (user.email !== 'admin') {
            <td class="text-center">
              <button class="btn btn-assign btn-xs" href="javascript:;" title="Assigned Projects" placement="left"
                [ngbPopover]="popContent" triggers="manual" #assignPopover="ngbPopover" popoverTitle="Assigned Projects" (click)="togglePopover(assignPopover, user)">
                <i class="fa fa-fw fa-book"></i> Assign
              </button>&nbsp;
              <a class="btn btn-edit btn-xs" [routerLink]="['/dashboard/user/edit/', (user.id)]" [state]="{ data: { user: user }}" title="Edit User"><i class="fa fa-fw fa-edit"></i> Edit</a>&nbsp;
              <button class="btn btn-delete btn-xs" href="javascript:;" (click)="deleteUser(user)" title="Delete User"><i class="fa fa-fw fa-trash"></i> Delete</button>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
  <!-- Pagination Interface -->
  @if (pagination['show']) {
    <nav aria-label="Page navigation">
      <ul class="pagination">
        <li class="page-item"><a class="page-link" [ngClass]="(currentPage == 1 ) ? 'disabled' : ''" href="javascript:;" (click)="paginate('previous')">Previous</a></li>
        <li class="page-item"><a class="page-link text" href="javascript:;">Page {{currentPage}} of {{pagination['pages']}}</a></li>
        <li class="page-item"><a class="page-link" [ngClass]="(currentPage == pagination['pages'] ) ? 'disabled' : ''" href="javascript:;" (click)="paginate('forward')">Next</a></li>
      </ul>
    </nav>
  }
</div>

<ng-template #popContent let-user="user">
  @if (user.projects.length > 0) {
    <ul class="assigned-users">
      @for (project of user.projects; track project) {
        <li>{{ project.name }}</li>
      }
    </ul>
  }
  @if (user.projects.length === 0) {
    <div>No projects assigned</div>
  }
  <a [routerLink]="['/dashboard/user/assign/', (user.id)]" [state]="{ data: { user: user }}"  title="Assign Project">Assign/Modify Project</a>
</ng-template>